import HighlightCard from "@components/HighlightCard"
import breakpoints from "@constants/breakpoints"
import { h3Styles, h4Styles } from "@constants/typography"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  padding-top: 68px;

  @media ${breakpoints.tablet} {
    padding: 118px 0 0;
  }

  @media ${breakpoints.laptop} {
    padding: 162px 0 170px;
  }
`

const Header = styled.div`
  ${h4Styles}
  width: 100%;
  padding: 0 20px;
  margin-bottom: 40px;

  @media ${breakpoints.tablet} {
    ${h3Styles}
    margin-bottom: 62px;
    padding: 0 calc(1 / 12 * 100vw);
  }

  @media ${breakpoints.laptop} {
    margin-bottom: 54px;
    padding: 0 calc(1 / 12 * 100vw);
  }
`

const CardWrapper = styled.div`
  @media ${breakpoints.tablet} {
    margin-bottom: 106px;
  }

  @media ${breakpoints.laptop} {
    margin-bottom: 66px;
  }
`

const ExploreBlock = ({ cards }) => {
  return cards && cards.length > 0 ? (
    <Container>
      <Header>Explore the Series</Header>
      {cards?.map((card: any, idx: number) => (
        <CardWrapper key={idx}>
          <HighlightCard
            autoplayVideo={card.autoplayVideo}
            callToActionButtonLink={card.callToActionButtonLink}
            callToActionButtonText={card.callToActionButtonText}
            description={card.description?.description}
            descriptionColor={card.descriptionColor}
            fiftyPercentMedia={card.fiftyPercentMedia}
            footer={card.footer}
            footerColor={card.footerColor}
            icon={card.icon?.file?.url}
            image={card.image?.file?.url}
            imageGif={card.imageGif?.file?.url}
            justification={card.justification}
            largeTitle={card.largeTitle}
            mobileImage={card.mobileImage?.file?.url}
            mobileImageGif={card.mobileImageGif?.file?.url}
            mobileVideoUrl={card.mobileVideoUrl}
            muxMobileVideo={card.muxMobileVideo}
            muxVideo={card.muxVideo}
            title={card.title}
            titleColor={card.titleColor}
            videoThumbnail={card.videoThumbnail?.file?.url}
            videoUrl={card.videoUrl}
            wistiaEmbedCode={card.wistiaEmbedCode}
            wistiaVideoId={card.wistiaVideoId}
          />
        </CardWrapper>
      ))}
    </Container>
  ) : null
}

export default ExploreBlock
